import React from 'react';
import { Button } from 'antd';
import { EyeOutlined, CheckCircleOutlined, ExclamationCircleOutlined, ClockCircleOutlined, ReloadOutlined, LoadingOutlined } from '@ant-design/icons';

import uploadCircleSvg from 'assets/images/upload-svg.svg';
import fileSvg from 'assets/images/file.svg';
import clipSvgReview from 'assets/images/clip-fill-purple.svg';
import clipSvgApproved from 'assets/images/clip-fill-green.svg';
import deleteSvg from 'assets/images/delete.svg';
import checkCircleSvg from 'assets/images/check-circle-basic.svg';
import checkCircleSvgApproved from 'assets/images/check-circle-approved.svg';
import iconErrorSvg from 'assets/images/error-red.svg';
import iconClockSvg from 'assets/images/clock-fill-review.svg';
import { File } from '@common/utils/interfaces/file.interface';
import { TaskState } from 'gql/graphql';

type UploadStatus = 'pending' | 'uploading' | 'success' | 'error';

interface InputUploadedFileProps {
  file: File;
  seeFile?: Function;
  deleteFile?: Function | any;
  loadingDeleteFile?: boolean;
  state?: TaskState | undefined;
  isActionSeeFile?: boolean;
  icon?: string;
  uploadStatus?: UploadStatus;
  errorMessage?: string;
  onRetry?: Function;
}

const InputUploadedFile = ({
  file,
  seeFile,
  deleteFile,
  loadingDeleteFile,
  state,
  isActionSeeFile,
  icon,
  uploadStatus,
  errorMessage,
  onRetry
}: InputUploadedFileProps) => {

  let hiddenIconStart = false;

  const renderUploadStatusIcon = () => {
    if (!uploadStatus) return null;
    switch (uploadStatus) {
      case 'pending':
        return <ClockCircleOutlined style={{ color: '#8c8c8c', fontSize: 16 }} />;
      case 'uploading':
        return <LoadingOutlined style={{ fontSize: 16, color: '#1890ff' }} />;
      case 'success':
        return <CheckCircleOutlined style={{ color: '#52c41a', fontSize: 16 }} />;
      case 'error':
        return <ExclamationCircleOutlined style={{ color: '#ff4d4f', fontSize: 16 }} />;
      default:
        return null;
    }
  };

  const _seeFile = (files: File) => {
    if (files?.url !== undefined && files?.url !== "") {
      var win: any = window.open();
      const isPendingUpload = files.url.startsWith('data:');
      if (isPendingUpload) {
        win.document.write(`<iframe width='100%' height='100%' src="${files.url}"><\/iframe>`);
      } else {
        win.document.write(`<iframe width='100%' height='100%' src="${files.url}?preview=true&app=borrower"><\/iframe>`);
      }
    }
  };

  return (
    <div className="InputUploadedFile">
      <div className="file-ok">
        <div className="file" style={{ paddingLeft: !hiddenIconStart ? 7 : 0 }}>
          {!hiddenIconStart && (
            <div className="circle-input">
              {state?.toUpperCase() === TaskState.Approved &&
                <img src={checkCircleSvgApproved} alt="upload" className="upload" />
              }
              {state?.toUpperCase() === TaskState.RequestError &&
                <img src={iconErrorSvg} alt="upload" className="upload" />
              }
              {state?.toUpperCase() === TaskState.Review &&
                <img src={iconClockSvg} alt="upload" className="upload" />
              }
              {(!state || state?.toUpperCase() === TaskState.Draft || state?.toUpperCase() === TaskState.Incomplete) && 
                <img src={uploadCircleSvg} alt="upload" className="upload" />
              }
            </div>
          )}
          <div className={`file-content file-content-${state}`}>
            <div className="flex-btw">
              <div className="file-name">
                {!state || state === undefined &&
                  <img className="fileIcon" alt="fileIcon" src={fileSvg} />
                }
                {state?.toUpperCase() === TaskState.Review &&
                  <img className="fileIcon" alt="fileIcon" src={clipSvgReview} />
                }
                {state?.toUpperCase() === TaskState.Approved &&
                  <img className="fileIcon" alt="fileIcon" src={clipSvgApproved} />
                }
                <span className="name">{file?.name}</span>
              </div>
              <div className="content-buttons">
                {uploadStatus && (
                  <span style={{ marginLeft: 8 }}>
                    {renderUploadStatusIcon()}
                  </span>
                )}
                {seeFile && (
                  <Button
                    className="button button-transparent sent"
                    onClick={() => seeFile(file)}
                  >
                    <EyeOutlined />
                  </Button>
                )}
                {isActionSeeFile && (
                  <Button
                    className="button button-transparent local"
                    onClick={() => _seeFile(file)}
                  >
                    <EyeOutlined />
                  </Button>
                )}
                {uploadStatus === 'error' && onRetry && (
                  <Button
                    className="button button-transparent"
                    onClick={() => onRetry()}
                    title="Retry upload"
                  >
                    <ReloadOutlined style={{ color: '#ff4d4f' }} />
                  </Button>
                )}
                {deleteFile && !uploadStatus && (
                  <Button
                    className="button button-transparent"
                    loading={loadingDeleteFile}
                    onClick={() => deleteFile(file)}
                  >
                    <img
                      src={deleteSvg}
                      alt="delete"
                      className="delete"
                      width="15"
                    />
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default InputUploadedFile;
